import React, { Component } from 'react'
import FormTareaMovimiento from '../components/FormTareaMovimiento'
import { Card } from 'react-bootstrap'
import { FORM_TAREA_MOVIMIENTO } from '../../../config/forms'
import { formValueSelector, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import * as actions from '../actions'
import TablaMovimientosMercaderiaPendientes from '../../Movimiento/TablasSinAsignar/movimientosMercaderia/containers/TablaMovimientosMercaderiaPendientes'
import { toast } from 'react-toastify'
import moment from 'moment'

const selector = formValueSelector(FORM_TAREA_MOVIMIENTO)

class TareaMovimiento extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.updateState = this.updateState.bind(this)
  }

  componentDidMount () {
    this.props.getTareasPendientes()
    this.props.getTareas()
  }

  updateState () {
    const { change: formChange } = this.props
    formChange('tarea', '')
    formChange('fechaInicio', (moment().format('YYYY/MM/DD')))
    formChange('horaInicio', moment().format('HH:mm'))
    formChange('fechaFin', null)
    formChange('horaFin', null)
    formChange('toneladas', null)
  }

  handleSubmit (finalizada) {
    const { tarea, fechaInicio, horaInicio, fechaFin, horaFin, toneladas } = this.props

    const fInicio = moment(fechaInicio + ' ' + horaInicio).format('YYYY/MM/DD HH:mm:ss')
    if (tarea) {
      if (finalizada) {
        if (fechaFin) {
          const fFin = moment(fechaFin + ' ' + horaFin).format('YYYY/MM/DD HH:mm:ss')
          if (fInicio < fFin) {
            if (toneladas && toneladas > 0) {
              this.props.submitTareaMovimiento(fInicio, fFin, tarea, toneladas)
              this.updateState()
            } else {
              toast.error('Valor de toneladas incorrecto.')
            }
          } else {
            toast.error('La fecha de inicio debe ser menor a la fecha de finalización.')
          }
        } else {
          toast.error('Debe indicar la fecha de finalización de la tarea.')
        }
      } else {
        this.props.submitTareaMovimientoPendiente(fInicio, tarea)
        this.updateState()
      }
    } else {
      toast.error('Debe seleccionar una tarea.')
    }
  }

  render () {
    const { tareas } = this.props
    return (
      <>
        <Card className='shadow rounded card-tareas-movimiento'>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: 'white', marginBottom: '2%' }}>
            <h6 className='nombre-tabla-cm'>Movimientos internos de mercadería</h6>
          </Card.Header>
          <div className='tarea-movimiento'>
            <div className='formulario-tareas-movimiento'>
              <h6 className='title-form-tareas'>Registrar tarea de movimiento</h6>
              <FormTareaMovimiento tareas={tareas} handleSubmit={this.handleSubmit} />
            </div>
            <TablaMovimientosMercaderiaPendientes />
          </div>
        </Card>
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    tarea: selector(state, 'tarea'),
    fechaInicio: selector(state, 'fechaInicio'),
    horaInicio: selector(state, 'horaInicio'),
    fechaFin: selector(state, 'fechaFin'),
    horaFin: selector(state, 'horaFin'),
    toneladas: selector(state, 'toneladas'),
    tareas: state.cuadroDeMandoMovimientos.tareasMovimiento,
    tareasPendientes: state.cuadroDeMandoMovimientos.tareasPendientes
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_TAREA_MOVIMIENTO,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(TareaMovimiento))
